import { ProductOrderItemSerializable } from './product-order-item-serializable';

export class CharterOrderItemSerializable extends ProductOrderItemSerializable {
  purchaseOrderNumber: string = null;
  formUrl: string = null;
  formUrlKey: string = null;
  charterInvoiceType: number = null;
}
